import { buildDefaultDataProperty } from '@bingads-webui-campaign-react/ui-generator';

export const buildSchema = options => ({
  separatorStyles: {
    marginBottom: 20,
  },
  campaignSettings: {
    type: 'panel',
    header: {
      title: _TL_('Campaign settings'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onCampaignSettingsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      websiteURL: buildDefaultDataProperty({
        label: _TL_('Website URL'),
        dynamicProps: props => props.websiteURL,
      }),
      hd1: {
        type: 'horizontal-divider',
      },
      campaignName: buildDefaultDataProperty({
        label: _TL_('Campaign name'),
        dynamicProps: props => props.campaignName,
      }),
      hd2: {
        type: 'horizontal-divider',
      },
      locationTargeting: {
        type: 'location-targeting',
        dynamicProps: props => props.locationTargeting,
      },
      hd3: {
        type: 'horizontal-divider',
      },
      languages: {
        type: 'languages',
        dynamicProps: props => props.languages,
      },
      hd4: {
        type: 'horizontal-divider',
      },
      conversionGoals: {
        type: 'conversion-goals',
        dynamicProps: props => props.conversionGoals,
      },
    },
  },
  keywords: {
    type: 'panel',
    header: {
      title: _TL_('Keywords'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onKeywordsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      keywords: {
        type: 'keywords',
        dynamicProps: props => props.keywords,
      },
    },
  },
  ads: {
    type: 'panel',
    header: {
      title: _TL_('Ad'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onAdsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      adCreationPreview: {
        type: 'ad-creation-preview',
        dynamicProps: props => props.adCreationPreview,
      },
    },
  },
  budgetBid: {
    type: 'panel',
    header: {
      title: _TL_('Budget & bids'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onBudgetBidHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      budget: {
        type: 'budget',
        dynamicProps: props => props.budget,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      bidStrategy: {
        type: 'bid-strategy',
        dynamicProps: props => props.bidStrategy,
      },
      hd2: {
        type: 'horizontal-divider',
      },
      adSchedule: {
        type: 'ad-schedule-with-bid-adjustments',
        dynamicProps: props => props.adSchedule,
      },
      hd3: {
        type: 'horizontal-divider',
      },
      startEndDates: {
        type: 'start-end-dates',
        dynamicProps: props => props.startEndDates,
      },
      hd4: {
        type: 'horizontal-divider',
      },
      adDistribution: {
        type: 'ad-distribution',
        dynamicProps: props => props.adDistribution,
      },
    },
  },
});
